var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinnerThin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.5 5.938 2-3.464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.062 8.5 3.464-2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19 12h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m21.526 17.5-3.464-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17.5 21.526-2-3.464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12 23v-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 21.526 2-3.464"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m2.474 17.5 3.464-2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m1 12h4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m5.938 8.5-3.464-2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m8.5 5.938-2-3.464"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m12 5v-4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerThin);
export default __webpack_public_path__ + "static/media/spinner-thin.ed6b7535.svg";
export { ForwardRef as ReactComponent };